var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert top-alert d-flex align-items-top justify-content-between gap-3",class:_vm.cls},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}}),_c('i',{staticClass:"ion-close-round",attrs:{"title":"close"},on:{"click":function($event){return _vm.hide_alert()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }